import { render, staticRenderFns } from "./PeopleTourRewards.vue?vue&type=template&id=528abba4&scoped=true"
import script from "./PeopleTourRewards.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTourRewards.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PeopleTourRewards.vue?vue&type=style&index=0&id=528abba4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528abba4",
  null
  
)

export default component.exports